export type GlobalVariableProps = {
  theme: 'hi' | 'tag' | 'tsh' | 'hypertsh';
};

export const globalVariable: GlobalVariableProps = {
  theme: 'tag',
};
